import productTileStyles from '@src/SectionRenderer/sections/commonStyles/newHomePageProductTile.module.scss'

import type { CardChromeProps } from './card-display-options-context'

// Legacy-card tile styling for the 6-up home grids — shared by the home swimlane widgets
// (featured-products-showcase / personalised-products), mirroring the non-PL sections
// (BackToSchool / personalisedProducts) which pass these `newHomePageProductTile` classes
// to the shared `ProductCard`. The DS card sizes itself via `dsVariant`, but on the legacy
// path `dsVariant` is a no-op, so without these the legacy card falls back to its wider
// default typography and default heart position (larger text + misplaced wishlist icon vs
// the BFF render). Published on the leaf via `cardProps` on legacy renders only — the SVD
// DS card would render `productPriceClass` into its price DOM.
export const HOME_TILE_CHROME_PROPS: CardChromeProps = {
  titleClassName: productTileStyles.title,
  productPriceClass: productTileStyles.price,
  wishlistIconClassName: productTileStyles.wishlistWrapper,
  wishlistIconClass: productTileStyles.wishlistIcon,
  ratingTextClassName: productTileStyles.ratingText,
  excessOptionsTextClassName: productTileStyles.excessOptionsText,
}
